import React from 'react';
import { Link } from 'react-router-dom';
import './TenantNameLink.css';

type TenantNameLinkProps = {
  userId?: number | null;
  name?: string | null;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

const TenantNameLink: React.FC<TenantNameLinkProps> = ({ userId, name, className = '', onClick }) => {
  const label = (name || 'Tenant').trim() || 'Tenant';
  if (!userId) {
    return <span className={`tenant-name-text ${className}`.trim()}>{label}</span>;
  }
  return (
    <Link
      to={`/tenants/view/${userId}`}
      className={`tenant-name-link ${className}`.trim()}
      onClick={onClick}
    >
      {label}
    </Link>
  );
};

export default TenantNameLink;
